import React, { useEffect, useState } from "react";
import axiosInstance from "../../api";
import Table from "../Homepage/Table";
import AddKilometreRate from "./AddKilometreRate";
import AddMaster from "./AddMaster";

function KilometreRate() {
  const tablehead = ["Year", "Rate"]
  const [tabledata, setTabledata]= useState([]);
  const [loading, setloading]= useState(false);
  const [showaddform, setshowaddform]= useState(false);
  const [reload, setReload]= useState(false);
  const [triggerupdate, settriggerupdate]= useState(false);
  const [datareload, setdatareload] = useState(0);
  const [rateupdatedata, setrateupdatedata] = useState(null);

  function fetchdata(id) {
    const url = `${process.env.REACT_APP_API_URL}/api/KilometreRate/GetSingle/${id}`;
    axiosInstance
      .get(url)
      .then((res) => {
        setrateupdatedata(res.data);
      })
      .catch(console.log);
  }

  useEffect(() => {
    axiosInstance
      .get(`${process.env.REACT_APP_API_URL}/api/KilometreRate/GetAll`)
      .then((res) => {
        setTabledata(res.data?.map(x=> [x?.year, x?.kmRate]));
      })
      .catch(console.log);
  }, [reload]);
  return (
    <section className="kilometre-rate-master">
      <h1>Kilometre Rate Master</h1>
      <blockquote className="hsn-master-forms">
        <AddMaster
          text="Add kilometer Rate"
          setshowaddform={setshowaddform}
          settriggerupdate={settriggerupdate}
          setshowsearchform={()=>false}
          permit={()=>false}
          
        />

      </blockquote>
      {showaddform && (
        <AddKilometreRate
          setshowaddform={setshowaddform}
          reload={reload}
          setReload={setReload}
          triggerupdate={triggerupdate}
          rateupdatedata={rateupdatedata}
          key={`${rateupdatedata?.kmRate}-${triggerupdate}-${datareload}`}
        />
      )}
      <Table 
        tablehead={tablehead} 
        tabledata={tabledata} 
        fetchdata={fetchdata}
        readPermission={()=>true}
        updatePermission={()=>false}
        deletePermission={()=>false}
        loading={loading}
        setdatareload={setdatareload}
        datareload={datareload}
        setshowaddform={setshowaddform}
        settriggerupdate={settriggerupdate}
        reload={reload}
        setReload={setReload}
      />
    </section>
  );
}

export default KilometreRate;
